import { atom, DefaultValue } from 'recoil';
import { formatCompleteISO, toDate } from '@zurich/common/forms';
import { isClean, objectUtils } from '@zurich/common/utils';
import { getComparableOffer, paymentIntervalUtils, paymentWayUtils, } from '@zurich-client/typeutils/contract';
// default for the atom
const offerDefault = {
    salesChannel: 'TiedAgent',
    insuredObjects: [],
    products: [],
    discounts: [],
    state: 'calculationState',
    application: {
        id: undefined,
        creationDate: undefined,
        legacyApproval: {
            requesterComment: undefined,
            //FIXME: approverCommentDiscountViolation: undefined,
            //FIXME: approverCommentPolicyViolation: undefined,
        },
    },
    deliveryInformation: {
        policyDocOriginal: 'policyHolder',
        policyDocCopy: 'non',
        differentDeliveryAddress: false,
        differentDeliveryAddressText: undefined,
    },
    intermediaryInformation: {
        intermediaryAccounts: [],
        usedIntermediaryAccount1: undefined,
        usedIntermediaryAccount2: undefined,
    },
    parties: [],
    participantRoles: [],
    paymentWay: paymentWayUtils.createDefaultValue && paymentWayUtils.createDefaultValue(), // TODO:
    paymentInterval: paymentIntervalUtils.createDefaultValue && // TODO:
        paymentIntervalUtils.createDefaultValue(),
    paymentAccount: undefined,
    austrianLaw: 'true',
    replacedPolicyNo: [],
    replacementApplication: undefined,
    approvalDecisions: [],
    questionnaire: {
        previousInsurance: {
            questionType: 'q_previousInsurance',
            affectedSegment: [],
        },
        genericQuestions: [],
        motorGeneralQuestions: {
            questionType: 'q_motorGeneral',
            environmentDiscount: 'noDiscount',
            changeOfVehicle: false,
            noYearlyPaymentSurcharge: false,
            boMaOld: 9,
            boMaNew: 9,
        },
    },
};
export const offerAtom = atom({
    key: '@zurich/contract/api/offer',
    default: offerDefault,
    effects: [
        ({ onSet, setSelf }) => {
            // this is an awesome way to get the old and new offer when it's updated without having to save the old offer as an atom
            onSet((newOffer, oldOffer) => {
                if (oldOffer instanceof DefaultValue || !oldOffer.id) {
                    // the first change will not be tracked
                    return;
                }
                if (newOffer instanceof DefaultValue) {
                    throw new Error('reset not implemented in offer atom effect');
                }
                const newComparableOffer = getComparableOffer(newOffer);
                const oldComparableOffer = getComparableOffer(oldOffer);
                let diff = objectUtils.diffObjs(oldComparableOffer, newComparableOffer);
                const equals = Object.keys(diff).length === 0;
                if (!equals) {
                    // sanatize
                    const maliciousInputKey = isClean(diff);
                    if (maliciousInputKey) {
                        setSelf({
                            ...oldOffer,
                        });
                        console.error(`We found an malicious input at ${maliciousInputKey}`);
                        return;
                    }
                    // update tracking information
                    const timestamp = Date.now();
                    setSelf({
                        ...newOffer,
                        tracking: {
                            timestamp,
                            sidebarChanged: newOffer.paymentInterval !== oldOffer.paymentInterval ||
                                newOffer.paymentWay !== oldOffer.paymentWay,
                        },
                    });
                    const newComparableAdaptedOffer = getComparableOffer(newOffer);
                    diff = objectUtils.diffObjs(oldComparableOffer, newComparableAdaptedOffer);
                    const dateStr = formatCompleteISO(toDate(new Date(timestamp)));
                    // debugging
                    console.group(`OFFER UPDATE DIFFERENCE ${timestamp} => ${dateStr}`);
                    console.debug(diff);
                    console.groupEnd();
                }
                else {
                    console.debug('OFFER UPDATE SKIPPED');
                }
            });
        },
    ],
});
